import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const SkladContext = createContext({
  activeSklad: "all",
  setActiveSklad: () => {},
  sklads: [],
});

export function SkladProvider({ children }) {
  const [activeSklad, _set] = useState(
    () => localStorage.getItem("yt_active_sklad") || "all"
  );
  const [sklads, setSklads] = useState([]);

  useEffect(() => {
    api
      .get("sklad/")
      .then((r) => {
        const list = Array.isArray(r.data) ? r.data : r.data?.results || [];
        setSklads(list);
      })
      .catch(() => {});
  }, []);

  const setActiveSklad = (v) => {
    _set(v);
    localStorage.setItem("yt_active_sklad", v);
  };

  return (
    <SkladContext.Provider value={{ activeSklad, setActiveSklad, sklads }}>
      {children}
    </SkladContext.Provider>
  );
}

export const useSklad = () => useContext(SkladContext);
